import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import reportWebVitals from "./reportWebVitals";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { Provider } from "react-redux";
import { store } from "./store";
import { captchaKey } from "./static/captchaKey";
import { ErrorBoundary } from "./components/errorBoundary";
import { notification } from "antd";

import "./index.css";

notification.config({
  placement: "bottomLeft",
  bottom: 24,
  duration: 4.5,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <GoogleReCaptchaProvider reCaptchaKey={captchaKey}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </GoogleReCaptchaProvider>
  </Provider>
);

reportWebVitals();
